export default __webpack_public_path__ + "static/media/DSC00124.c6f1760b.jpg";